import { useEffect } from 'react';
import type { StorageAllocationProposalResponse } from 'src/apis/storage/types';
import type { StorageOfferDetailsRequest } from 'src/apis/storage/use-storage-offer-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageOfferDetails?: StorageOfferDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalStorageAllocationProposal({
  storageOfferDetails,
}: HookOptions) {
  const allocationProposal = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) => {
      return axios.request<StorageAllocationProposalResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageOfferDetails?.response) return;
    if (!storageOfferDetails.response.data._links.getOfferAllocationProposal)
      return;

    allocationProposal.execute({
      url: storageOfferDetails.response.data._links.getOfferAllocationProposal
        .href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageOfferDetails?.response]);

  if (!storageOfferDetails) return;

  if (
    storageOfferDetails.response &&
    !storageOfferDetails.response.data._links.getOfferAllocationProposal
  )
    return;

  return allocationProposal;
}

export type StorageAllocationProposalRequest = ReturnType<
  typeof useOptionalStorageAllocationProposal
>;
